import { Button, Heading, Paper, Text } from '@components'
import { useAuth } from '@state'
import 'cropperjs/dist/cropper.min.css'
import { ScanSearch } from 'lucide-solid'
import { type Setter, Show } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'

export default function (props: {
	setIsOpen: Setter<boolean>
}) {
	const { isRifleman, isRecruit } = useService(useAuth)()
	const canAccessHvfTool = () => !isRifleman() && !isRecruit()

	return (
		<Paper>
			<Grid
				gridTemplateColumns={{
					base: '1fr',
					mdToXl: '1fr auto',
				}}
				justifyContent="space-between"
				alignItems="center"
			>
				<Grid gap={2}>
					<Heading>HVF Scan tool</Heading>
					<Text size="sm">
						Prefill technical data by scanning your HVF draw tool images
						<Show when={!canAccessHvfTool()}>
							<Text size="xs">
								Availble to those who have completed the one-year TMP and hold an active
								annual subscription
							</Text>
						</Show>
					</Text>
				</Grid>
				<Button
					disabled={!canAccessHvfTool()}
					onClick={() => props.setIsOpen(true)}
					colorPalette="tscGreen"
					variant="outline"
					size="xs"
				>
					Draw Tool Scanning
					<ScanSearch />
				</Button>
			</Grid>
		</Paper>
	)
}
